export const INSURANCE = "INSURANCE";
export const INSURANCE_SUCCESS = "INSURANCE_SUCCESS";
export const INSURANCE_ERROR = "INSURANCE_ERROR";
export const INSURANCE_CLEAR_DATA = "INSURANCE_CLEAR_DATA";
